// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"512":"5b7885bb848ede58062a","992":"a29ce42e938ed01bd2a9"}[chunkId] + ".chunk.js";
};